<div class="w-10 py-4 m-auto">
    <h4>{{ fullInteractionList.length }} interacciones de {{ totalInteractions }} en total</h4>
    <p-table #dt1 [value]="fullInteractionList" sortField="interactionDate" [sortOrder]="-1" 
        [tableStyle]="{'min-width': '5rem'}" [scrollable]="true" scrollHeight="400px"
        styleClass="p-datatable-striped p-datatable-gridlines">
        <ng-template pTemplate="header">
            <tr>
                <th>Fecha</th>
                <th class="flex flex-row gap-3 align-items-center justify-content-center">
                    Tipo
                    <p-columnFilter field="type" matchMode="equals" [showMenu]="false" [showClearButton]="true">
                        <ng-template pTemplate="filter" let-value let-filter="filterCallback">
                            <p-dropdown [(ngModel)]="selectedType" [options]="interactionTypes" placeholder="Filtrar" (onChange)="filter($event.value)" >
                            </p-dropdown>
                        </ng-template>
                    </p-columnFilter>
                </th>
                <th>Perfil</th>
                <th>Información adicional</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-interaction>
            <tr>
                <td class="w-2">
                    {{ interaction.interactionDate }}
                </td>
                <td class="w-2">
                    {{ interaction.type }}
                </td>
                <td class="w-2">
                    <a class="text-color" [routerLink]="getUrlProfile(interaction.person.urlId)" target="_blank">
                        <span class="pi pi-external-link"></span> {{ interaction.person.name }} - {{ interaction.person.urlId }}
                    </a>
                </td>
                <td class="w-6 overflow-hidden">
                    {{ interaction.additionalInfo }}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div>
        <h2>Perfiles por interacción</h2>
        <p-button label="Cargar estadísticas" (onClick)="loadChart()" [loading]="loading"></p-button>
        <div *ngIf="showChart" style="height: 400px; max-height: 400px;" class="overflow-scroll">
            <p-chart type="bar" height="5000px" [data]="data" [options]="options" />
        </div>
    </div>
</div>